import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import Register from './views/Register.vue'
import store from './store.js'
import axios from 'axios'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login,
      meta: {
        layout: 'login'
      }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('./views/Dashboard.vue'),
    },
    {
      path: '/mon-compte',
      name: 'account',
      component: () => import('./views/account/MyAccount.vue'),
    },
    {
      path: '/elections',
      name: 'electionList',
      component: () => import('./views/election/List.vue'),
    },
    {
      path: '/elections/:id',
      name: 'electionView',
      component: () => import('./views/election/View.vue'),
    },
    {
      path: '/users',
      name: 'usersList',
      component: () => import('./views/user/List.vue'),
    },
    {
      path: '/users/create',
      name: 'usersCreate',
      component: () => import('./views/user/Create.vue'),
    },
    {
      path: '/users/:id',
      name: 'usersView',
      component: () => import('./views/user/View.vue'),
    },
    {
      path: '/mail',
      name: 'mail',
      component: () => import('./views/mail/Template.vue'),
    },
    {
      path: '*',
      name: 'Error',
      component: () => import('./views/Error404.vue'),
      meta: {
        hiddenSidebar: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  /*
  if (to.matched.some(record => record.name == 'Error')) {
    next()
  } else {
    if (!store.getters.isLoggedIn) {
      next('/')
    } else {
      if (to.matched.some(record => record.meta.requiresElection)) {
        if (store.getters.election) next()
        else next('/election')
      } else {
        next()
      }
    }
  }*/

  if (to.matched.some(record => record.name == 'Error')) {
    next()
  } else {
    if (to.matched.some(record => record.name == 'login' || record.name == 'register')) {
      if (store.getters.isLoggedIn) next('/dashboard')
      else next()
    }else{
      if (store.getters.isLoggedIn) next()
      else next('/')
    }
  }

})

export default router



// WEBPACK FOOTER //
// ./src/router.js